module.exports = "https://static.wmbcdn.com/uniweb/images/3b00fa78204ad7b1d933b55750981371.svg";